import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Checkbox, Grid,
         Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography
} from '@mui/material';

import AppBindStyles from '../../AppBindStyles';

import LandingPreviewDialog from './LandingPreviewDialog';
import LandingPreview from './LandingPreview';
import LandingHeaderDisplay from './LandingHeaderDisplay';

import PageTitle from '../ui/PageTitle';
import SaveButton from '../ui/SaveButton';
import ServerError from '../ui/ServerError';

const abEnvironment = new AbEnvironment();
const SubscriptionOrderLandingCreateQuery = graphql`
query SubscriptionOrderLandingCreateQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    logo
    accountPath
    appTsByAccountId(orderBy:APP_NAME_ASC) {
      totalCount
      nodes {
         appId
         appName
         appSku
         appStatus
         cpAppTsByAppId {
          totalCount
          nodes {
            cpId
            cpTByCpId {
              programName
            }
          }
        }
      }
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1
    },
    flex: {
      flex: 1,
    },
    container: {
      position: 'relative',
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    sectionTitle: {
      marginBottom: 0
    },
    previewButton: {
      marginTop: 8,
      marginBottom: 8,
      marginRight: 0
    },
    formControl: {
      marginTop: -8
    },
});

class SubscriptionOrderLandingCreate extends Component {

  constructor(props) {
    super(props);

    this.state = {

      saveClicked: false,

      accountId: abEnvironment.getUserAttribute('a_id'),
      
      landingPath: '',
      pId: '',
      pageTitle: '',
      commissionTitle: '',
      appSelections: [],
      noAppsDefined: true,

      saveStatus:           null,
      saveMessage:          null,
      saveSnackbarOpen:     false,
      saveSnackbarDuration: null,

      showPreview:          false
    }
  }

  componentDidMount() {
    if (abEnvironment.isSegmentActive()) {  window.analytics.track('Creating a landing page'); }

  }

  onSnackbarClose() {
    this.setState( {saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
  }


  isRequiredFieldInError = (state_member) => {
    if (state_member === '' && this.state.saveClicked) {
      return 'Field is required';
    } else {
      return '';
    }

  }

  isLandingPathInError = () => {
    
    if (this.isRequiredFieldInError(this.state.landingPath) !== '') {
      return this.isRequiredFieldInError(this.state.landingPath);
    }

    if (this.state.landingPath.indexOf(' ') >= 0) {
      return 'Field cannot have spaces'
    }

    return '';
  }

  isAppSelectionInError = () => {
    // if saved has been clicked, see if one app is selected.
    if (!this.state.saveClicked) {
      return false;
    } 

    let oneAppSelected = false;
    let i = 0;
    for (i = 0; i < this.state.appSelections.length; i++) {
      let appT = this.state.appSelections[i]
      if (appT.selected === true) {
        oneAppSelected = true;
        break;
      }
    }
    if (oneAppSelected === true) {
      return false;
    } else {
      return true;
    }

  }


  getValueForRender = (state_member, prop_member, theDefault) =>  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
    {
      state_member = prop_member;
      return prop_member;
    }

    return theDefault;
  }

  
  goBack() {
    this.props.history.goBack();
  }

  handleChange = name => event => {
      this.setState({[name]: event.target.value});
  };

  isAppSelected = (appId) => {
    let i = 0;
    for (i = 0; i < this.state.appSelections.length; i++) {
      let app = this.state.appSelections[i];
      if (app.appId === appId) {
        if (app.selected === 1) {
          return true;
        } else {
          return false;
        }
      } 
    }
    return false;
  }

  areAppsSelected = () => {
    let i = 0;
    for (i = 0; i < this.state.appSelections.length; i++) {
      let app = this.state.appSelections[i];
      if (app.selected === true) {
        return true;
      } 
    }
    return false;
  }

  updateAppSelection = (appT) => {

    let mutableArray = [];
    let i = 0;
    let found = false;
    for (i = 0; i < this.state.appSelections.length; i++) {
      let app = this.state.appSelections[i];
      if (app.appId === appT.appId) {
        app.selected = !app.selected;
        found = true;
      } 
      mutableArray.push(app);
    }
    if (!found) {
      let appName = '';
      if (appT.appSku == null || appT.appSku === '') {
        appName = appT.appName;
      } else {
        appName = appT.appName + " (" + appT.appSku + ")";
      }
      let programName = 'This app is not in a program';
      let cpId = null;
      if (appT.cpAppTsByAppId.totalCount > 0) {
        programName = appT.cpAppTsByAppId.nodes[0].cpTByCpId.programName;
        cpId = appT.cpAppTsByAppId.nodes[0].cpId;
      }

      let appSelection = {'appId' : appT.appId, 'appName': appName, 'selected' : true, 'cpId' : cpId, 'programName': programName};      
      mutableArray.push(appSelection);
    }

    this.setState({appSelections: mutableArray});
  }

  handlePreviewDialogClose = () => {
    this.setState({showPreview: false});
  };
  
  setProgramId = (aValue) => {
    this.setState({pId: aValue});
  };

  disableSave = () => {

    if (this.isLandingPathInError() !== '')
      return true;

    if (!this.areAppsSelected())
      return true;


    return false;
  }

  /*previewClicked = () => {
    //see this for more information: https://stackoverflow.com/questions/30782948/why-calling-react-setstate-method-doesnt-mutate-the-state-immediately
    this.setState({saveClicked: true}, function () {

      if (this.disableSave()) {
        return;
      } else {
        this.setState({showPreview: true});        
      }
    });
  }*/

  /*savedClicked = () => {
    //see this for more information: https://stackoverflow.com/questions/30782948/why-calling-react-setstate-method-doesnt-mutate-the-state-immediately
    this.setState({saveClicked: true}, function () {
      this.createLandingPage();
    });
  }*/

  createLandingPage = () => {
    

    if (this.disableSave()) {
       return;
    }

    this.setState({saveStatus: 'saving'});
    
    const { callPartnerApi } = this.props.auth;

    let accountId = abEnvironment.getUserAttribute('a_id');
    let aPjwt = abEnvironment.getPjwt();
    let success = false;


    //get all the selected apps
    let i = 0;
    let appsToAdd = [];
    let appToAdd = {};
    for (i = 0; i < this.state.appSelections.length; i++) {
      let app = this.state.appSelections[i];
      if (app.selected === true) {
        appToAdd = {
          "appId": app.appId,
          "appMarkupPercentage": "0.0",
          "paymentOrder": 0,
        };
        appsToAdd.push(appToAdd);
      } 
    }

    // We are setting parm value to "so_<landingPath>"
    let theParmValue = "so_" + this.state.landingPath;
    let theBody = {
      "accountId": accountId,
      "landingPath": this.state.landingPath,
      "programId": this.state.pId,
      "pageTitle": this.state.pageTitle,
      "commissionTitle": this.state.commissionTitle,
      "logo": this.state.logo,
      "parmValue": theParmValue,  
      "apps": appsToAdd
    };

    let payload = {
      operation: "createSOAccountLanding",
      params: {
        pJwt:             aPjwt,
        accountId:        accountId,
        body:             theBody
      }
    }
     
    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    ).then((response) => {
      if (response.status === 200) {
        success = true;
      }
      return response.json();
    })
    .then(response => {
      if (success) {

        this.setState({ saveStatus: 'success' });
        this.goBack();

      } else {

        let theMessage = 'Unable to save subscription order page';  //default
        if (response.err != null)
        {
          theMessage = response.err.errMessage;  //more specific
        }
        this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: theMessage, saveSnackbarDuration: null });

      }
    })
    .catch(error => {
      this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to save subscription order page', saveSnackbarDuration: null });
    });


  }

  render() {
    const { isAuthenticated, isAuthenticatedVendor, needAssent, logError  } = this.props.auth;
    const classes = this.props.classes;

    let appCounter = 0;
    let accountId = abEnvironment.getUserAttribute('a_id');

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedVendor()) {
      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={SubscriptionOrderLandingCreateQuery}
          variables={{accountId: accountId}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              let accountLogo = null;
              if (props.accountTByAccountId) {
                accountLogo = props.accountTByAccountId.logo
              }

              let accountPath = props.accountTByAccountId.accountPath;

              return (
                <Grid container spacing={3} direction="row" justifyContent="flex-start">
                  <Grid item xs={12}>
                    <PageTitle title="Add subscription order" showBackButton={true} name="landing pages" noMargin={true} history={this.props.history}/>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      <LandingHeaderDisplay logo={accountLogo}
                                            accountPath={accountPath}
                                            landingPath={this.state.landingPath}
                                            landingName={this.state.landingName}
                                            displayMode="so"/>


                      <Grid container spacing={2}  style={{marginTop: 24}} direction="row" justifyContent="space-between">
                        <Grid item xs={12} md={6}>
                          <TextField
                            error={this.isLandingPathInError() !== ''}
                            id="landing-path" label="Landing path *"
                            value={this.state.landingPath}
                            onChange={(e) => this.setState({ landingPath: e.target.value })}
                            inputProps={{ maxLength: 32 }}
                            helperText={this.isLandingPathInError()}
                            />
                        </Grid>

                        <Grid item xs={12}>
                          <Grid container spacing={0} className={classes.sectionTitle} direction="column" justifyContent="flex-start">
                            <Grid item>
                              <Typography variant="h6">Customize your subscription order</Typography>
                            </Grid>
                            <Grid item>
                              <Typography variant="body2">Set label values for your subscription order</Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <TextField
                            id="landing-title" label="Page title"
                            value={this.state.pageTitle}
                            onChange={(e) => this.setState({ pageTitle: e.target.value })} 
                            inputProps={{ maxLength: 256 }}/>
                        </Grid>
        
                        <Grid item xs={12} md={6}>
                          <TextField
                            id="commission-title" label="Commission title"
                            value={this.state.commissionTitle}
                            onChange={(e) => this.setState({ commissionTitle: e.target.value })} 
                            inputProps={{ maxLength: 256 }}/>
                        </Grid>
        
                        {/*<Grid item xs={12}>
                          <Button variant="outlined" color="primary" className={classes.previewButton}  onClick={() => { this.previewClicked() }}>
                              <VisibilityIcon style={{marginRight: '8px'}} color="primary"/>Preview
                          </Button>
                        </Grid>*/}
      
                        <Grid item xs={12}>
                          <Grid container spacing={0} className={classes.sectionTitle} direction="column" justifyContent="flex-start">
                            <Grid item>
                              <Typography variant="h6">Set up apps and commissions</Typography>
                            </Grid>
                            <Grid item>
                              <Typography variant="body2">What apps will be added as defaults for resellers signing up through this subscription order?</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        
                        <Grid item xs={12}>
                          {/* Apps in table */}
                          <Paper>
                            <Table>
                              <TableHead style={AppBindStyles.tableHead}>
                                <TableRow style={AppBindStyles.tableHeadRow}>
                                  <TableCell/>
                                  <TableCell className={classes.tblHeadCell}>App</TableCell>
                                  <TableCell className={classes.tblHeadCell}>Commission program</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                              { props.accountTByAccountId.appTsByAccountId.nodes.map(n => {
                                let programName = 'This app is not in a program';
                                if (n.cpAppTsByAppId.totalCount > 0) {
                                  programName = n.cpAppTsByAppId.nodes[0].cpTByCpId.programName;
                                }

                                let appName = '';
                                if (n.appSku == null || n.appSku === '') {
                                  appName = n.appName;
                                } else {
                                  appName = n.appName + " (" + n.appSku + ")";
                                }
            
                                return (
                                  <TableRow key={(appCounter++).toString()}>
                                    <TableCell>
                                      <Checkbox checked={n.selected} onChange={() => this.updateAppSelection(n)} />
                                    </TableCell>
                                    <TableCell>{appName}</TableCell>
                                    <TableCell>{programName}</TableCell>
                                  </TableRow>
                                );
                              })}
                              </TableBody>
                            </Table>
                          </Paper>
                        </Grid>

                      </Grid>
                        <SaveButton
                            snackbarOpen={this.state.saveSnackbarOpen}
                            autoHideDuration={this.state.saveSnackbarDuration}
                            status={this.state.saveStatus} 
                            message={this.state.saveMessage}
                            disabled={this.disableSave()}
                            onSaveClick={() => {this.createLandingPage()}}
                            onSnackbarClose={() => { this.onSnackbarClose(); }}
                          />
      
                    </Paper>
                    {/* disabled={this.state.noAppsDefined || this.state.noProgramsDefined} */}
                    <LandingPreviewDialog
                      title="Landing Page Preview"
                      open={this.state.showPreview}
                      onClose={() => { this.handlePreviewDialogClose()}} >
        
                        <LandingPreview
                          landingLogo={this.getValueForRender(this.state.logo,  accountLogo, accountLogo)}
                          landingName={this.state.landingName}
                          landingTitle={this.state.landingTitle}
                          landingText={this.state.landingText}
                          signupText={this.state.signupText}
                          partnerLink={this.state.partnerLink}
                          partnerLinkText={this.state.partnerLinkText}
                          linkParameter={this.state.landingPath}
                  
                          onClose={() => { this.handlePreviewDialogClose()}}>
                        </LandingPreview>
        
                    </LandingPreviewDialog>
                  </Grid>
                </Grid>
              );
            }
          }}
        />
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

SubscriptionOrderLandingCreate.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(SubscriptionOrderLandingCreate);